var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPredict(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 186.1 186.1",
    style: {
      enableBackground: "new 0 0 186.1 186.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#064B93;}\n\t.st1{fill:#03968F;}\n\t.st2{enable-background:new    ;}\n\t.st3{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_797",
    transform: "translate(0 0.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Approve"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.1,110.5v59.3c0,8.9-7.2,16.2-16.2,16.2H16.2C7.3,186,0,178.7,0,169.8v-59.3H186.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.1,18.5v92H0v-92C0,8.2,8.3-0.1,18.6-0.1h148.9C177.8-0.1,186.1,8.2,186.1,18.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AP"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75,126.4c2,0,4,0.4,5.8,1.2c1.8,0.8,3.4,1.8,4.7,3.2s2.4,2.9,3.2,4.7c0.8,1.8,1.2,3.7,1.2,5.8 c0,2.1-0.4,4-1.2,5.8c-0.8,1.8-1.9,3.4-3.2,4.7s-2.9,2.4-4.7,3.2c-1.8,0.8-3.7,1.2-5.8,1.2H63.9v13h-5.8v-42.8H75z M75,150.6 c1.3,0,2.4-0.2,3.6-0.7c1.1-0.5,2.1-1.2,2.9-2c0.8-0.8,1.5-1.8,2-2.9c0.5-1.1,0.7-2.3,0.7-3.6c0-1.3-0.2-2.5-0.7-3.6 c-0.5-1.1-1.1-2.1-2-2.9c-0.8-0.8-1.8-1.5-2.9-2c-1.1-0.5-2.3-0.7-3.6-0.7H63.9v18.5H75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M130.9,139.9c0,1.7-0.3,3.3-0.9,4.9c-0.6,1.5-1.4,2.9-2.5,4.1c-1,1.2-2.3,2.2-3.7,2.9 c-1.4,0.8-3,1.3-4.6,1.5l11.6,15.9h-7.2l-11.6-15.8h-7.3v15.8h-5.8v-42.8h18.3c1.8,0,3.6,0.4,5.2,1.1c1.7,0.7,3.1,1.7,4.3,2.9 c1.2,1.2,2.2,2.7,2.9,4.3C130.6,136.3,130.9,138.1,130.9,139.9z M117.4,147.8c1.1,0,2.1-0.2,3.1-0.6c0.9-0.4,1.8-1,2.4-1.7 c0.7-0.7,1.2-1.5,1.6-2.5c0.4-1,0.6-2,0.6-3.1s-0.2-2.1-0.6-3.1c-0.4-1-0.9-1.8-1.6-2.5c-0.7-0.7-1.5-1.3-2.4-1.7 c-0.9-0.4-2-0.6-3.1-0.6h-12.5v15.8H117.4z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.5,67.7 95.8,1.5 121.3,1.5 1.5,88.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.6,3.1L3,85.3V68.5L96.3,3.1H116.6 M125.9,0.1H95.3L0,66.9v24.2L125.9,0.1L125.9,0.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.5,29.1 40.8,1.5 67.2,1.5 1.5,49.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.6,3.1L3,46.2V29.9L41.2,3.1H62.6 M71.8,0.1H40.3L0,28.3V52L71.8,0.1L71.8,0.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "164.8,41.5 157.1,65.7 152.4,59.7 149.7,61.8 110.9,92.4 110.6,92.1 95.4,74.7 93,76.3 50.4,106.2  48.6,103.7 42.1,95 39.5,96.9 22,109.8 0,109.8 0,106.2 44.5,75.2 44.5,75.2 51.7,84.7 53.3,86.9 99.1,54.7 111.5,70.1 113,71.9  113.1,71.9 144.3,49.5 138.5,42 138.5,42 138.5,42  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139,41l-0.2-0.2l-0.5,0.2h-1.4l1.1,2.3l0.2-0.1l4.7,6l-29.7,21.3L99.3,53.3L53.5,85.5l-8.2-10.9l-0.6-0.8 L0,104.9v2.4l44.3-30.8l8.8,11.7L98.9,56l13.9,17.3l32.9-23.6l-5.2-6.7l23-0.5l-6.8,21.1l-4.2-5.3L111,91L95.5,73.3l-44.9,31.5 l-8.3-11.2l-20.6,15.2H0v2h22.4l0.2-0.1l19.3-14.2l8.3,11.2l45-31.6l14.7,16.8l0.9,1l41.4-32.7l5.2,6.7l8.8-27.4L139,41z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPredict);
export default __webpack_public_path__ + "static/media/Logo-Predict.990aebf8dc3deb4e489627544063490c.svg";
export { ForwardRef as ReactComponent };